import React from 'react';

export default function RecordingIndicator({
  isRecording,
  isPaused,
  hasRecordedVideo,
  uploading,
  uploadPct,
}) {
  let content = null;
  let bg = 'rgba(0,0,0,0.6)';
  let color = '#fff';

  if (isRecording && !isPaused) {
    content = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ width: 10, height: 10, background: '#ff2d2d', borderRadius: '50%', boxShadow: '0 0 6px #ff2d2d' }} />
        <span style={{ fontWeight: 600 }}>REC</span>
      </div>
    );
  } else if (isRecording && isPaused) {
    content = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ width: 10, height: 10, background: '#ffaa00', borderRadius: '2px' }} />
        <span style={{ fontWeight: 600 }}>PAUSED</span>
      </div>
    );
  } else if (hasRecordedVideo && !uploading) {
    content = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ fontSize: 14 }}>⬆️</span>
        <span style={{ fontWeight: 600 }}>UPLOAD READY</span>
      </div>
    );
  } else if (uploading) {
    content = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ width: 10, height: 10, background: '#4da6ff', borderRadius: '50%' }} />
        <span style={{ fontWeight: 600 }}>UPLOADING {Math.max(0, Math.min(100, Math.round(uploadPct)))}%</span>
      </div>
    );
  }

  if (!content) return null;

  return (
    <div
      className="lrp-rec-indicator"
      style={{
        position: 'absolute',
        top: 8,
        left: 8,
        zIndex: 10,
        padding: '6px 10px',
        borderRadius: 6,
        background: bg,
        color,
        fontSize: 12,
        letterSpacing: '.5px',
        fontFamily: 'system-ui, sans-serif'
      }}
      aria-live="polite"
    >
      {content}
    </div>
  );
}
